module.exports = __webpack_public_path__ + "img/DSC1925.62495b8f.jpg";